/**
 * @file Especialização CPF do pipeline Input.
 * @module components/create/cpf
 */

/**
 * Configura um input textual com máscara e validação de CPF.
 *
 * Defaults: `dic.labels.cpf` como label e ícone `id-card` como prefixo. A
 * validação roda no blur e no keyup quando o valor está vazio ou completo com
 * 14 caracteres mascarados.
 *
 * @param {HTMLInputElement} elem Input base.
 * @param {Object} options Opções recebidas pelo componente.
 * @param {Function} [options.callback] Callback repassado ao validador `checkCPF`.
 * @returns {Array.<HTMLInputElement|Object>} Input e `options` normalizado.
 */
export default (elem, options) => {
  options.type = 'text';
  options.mask = { template: 'cpf' };

  if (!options.label) {
    options.label = dic.labels.cpf;
  }

  if (!options.prefix) {
    options.prefix = { icon: { name: 'id-card', type: 'solid' } };
  }

  if (options.callback && typeof options.callback === 'function') {
    elem.callback = options.callback;
  }

  elem.addEventListener('keyup', (e) => {
    const size = [0, 14];
    if (size.indexOf(e.target.value.length) >= 0) {
      e.target.checkCPF(e.target.callback);
    }
  });

  elem.addEventListener('blur', (e) => {
    e.target.checkCPF(e.target.callback);
  });

  return [elem, options];
}